"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMAIL_BCC_REQUESTED = exports.EMAIL_BCC_ENABLED = exports.EMAIL_BCC = exports.BCC_EMAIL = void 0;
var BCC_EMAIL = 'BccEmail';
exports.BCC_EMAIL = BCC_EMAIL;
var EMAIL_BCC = 'email:bcc';
exports.EMAIL_BCC = EMAIL_BCC;
var EMAIL_BCC_ENABLED = 'email:bccEnabled';
exports.EMAIL_BCC_ENABLED = EMAIL_BCC_ENABLED;
var EMAIL_BCC_REQUESTED = 'email:requestedBcc';
exports.EMAIL_BCC_REQUESTED = EMAIL_BCC_REQUESTED;